// Main plugins pages - converted to lazy loading
const pluginsIndex = () => import('@/pages/plugins/index')
// Plugins pages - converted to lazy loading
const zatcaIndex = () => import('@/pages/plugins/zatca/index')
const rsdIndex = () => import('@/pages/plugins/rsd/index')
const shortcutsIndex = () => import('@/pages/plugins/shortcuts/index.vue')
const onlineMenu = () => import('@/pages/plugins/onlineMenu/index.vue')
const routes = [
  // Main plugins pages
  {
    path: 'plugins',
    name: 'plugins',
    component: pluginsIndex
  },

  // Plugins pages
  {
    path: 'plugins/zatca',
    name: 'zatca',
    component: zatcaIndex
  },
  {
    path: 'plugins/rsd',
    name: 'rsd',
    component: rsdIndex
  },
  {
    path: 'plugins/shortcuts',
    name: 'shortcuts',
    component: shortcutsIndex
  },
  {
    path: 'plugins/onlineMenu',
    name: 'onlineMenu',
    component: onlineMenu
  }
]

export default routes
